import { createContext, useContext, useEffect, useState } from 'react';
import { resolveCurrentOrganization } from 'src/acl/ability';
import { useAuth } from 'src/contexts/AuthContext';
import { OrganizationType } from 'src/types/organization.type';

type OrganizationContextType = {
   organization: OrganizationType | null;
};

const OrganizationContext = createContext<OrganizationContextType>({
   organization: null
});

export const OrganizationProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
   const { user, isOrgAdmin, currentOrganizationId } = useAuth();
   const [organization, setOrganization] = useState<OrganizationType | null>(null);

   useEffect(() => {
      if (user && isOrgAdmin) {
         // NPT-2144: the org the admin is acting in (the cookie org), not just the first membership.
         setOrganization((resolveCurrentOrganization(user, currentOrganizationId) as OrganizationType | undefined) ?? null);
      }
   }, [user, isOrgAdmin, currentOrganizationId])

   return <OrganizationContext.Provider value={{ organization }}>{children}</OrganizationContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components -- co-located with its provider; splitting would ripple through every import site
export const useOrganization = () => {
   const context = useContext(OrganizationContext);
   if (!context) throw new Error('useOrganization must be used within OrganizationProvider');

   return context;
};
